export enum ModalType {
	NeedHelp,
	LearnMore,
	PushpayPrivacy,
	MerchantPrivacy,
	PushpayTerms,
	MerchantTerms,
}
